var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.04 23-7.915-7.916A8.31 8.31 0 0 1 2.435 2.436a8.31 8.31 0 0 1 12.65 10.688L23 21.04 21.042 23 21.04 23ZM8.31 2.77a5.54 5.54 0 1 0 4.04 1.751l.837.831-.944-.942-.017-.016A5.502 5.502 0 0 0 8.31 2.77Z",
    fill: "#333"
  })));
};
export default SvgSearch;